import { clients } from '@moovly/clients';
import { GroupStatisticsResponse, Metric } from '@moovly/clients/lib/resources/bi/bi.interfaces';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  DefaultApiRequestState,
  getDefaultApiRequestState,
  getDefaultReducerForAsyncRequest,
  RequestType,
} from '../../../store/default';
import { formatDateForBackend } from '../../../utils/date';
import { compareDesc } from 'date-fns';
export interface IMetricData {
  start: string;
  end: string;
  value: number;
}

type IParsedGroupStatisticsResponse = { [K in Metric]: IMetricData[] };

const transformGroupStatistics = (response: GroupStatisticsResponse) => {
  return response.ranges
    .sort((a, b) => compareDesc(new Date(a.start), new Date(b.start)))
    .reduce<IParsedGroupStatisticsResponse>(
      (accum, { start, end, stats }) => {
        stats.forEach((s) => {
          accum[s.metric].push({
            start: start,
            end: end,
            value: parseInt(s.value, 10),
          });
        });

        return accum;
      },
      {
        total_membership: [],
        returning_membership: [],
        create_membership: [],
        create_render: [],
        create_project: [],
      }
    );
};

export const getGroupStatistics = createAsyncThunk(
  'dashboard/statistics/getGroupStatistics',
  ({ groupId, start, end }: { groupId: string; start: Date; end: Date }) => {
    return clients.BI.getGroupStatistics(groupId, {
      start_date: formatDateForBackend(start),
      end_date: formatDateForBackend(end),
      grouping_range: 'month',
      metric: ['create_render', 'total_membership', 'create_project', 'create_membership', 'returning_membership'],
    }).then(transformGroupStatistics);
  }
);

type StatisticState = {
  group: DefaultApiRequestState<IParsedGroupStatisticsResponse, [RequestType.Get]>;
  activeGroupId: string | null;
};

const initialState: StatisticState = {
  group: getDefaultApiRequestState([RequestType.Get]),
  activeGroupId: null,
};

export const groupStatisticsSlice = createSlice({
  name: 'dashboard/statistics',
  initialState,
  reducers: {
    setGroup: (state, { payload }: PayloadAction<string>) => {
      state.activeGroupId = payload;
    },
    reset: () => initialState,
  },
  extraReducers: {
    ...getDefaultReducerForAsyncRequest({
      thunk: getGroupStatistics,
      getInitialState: (state) => state.group,
      requestType: RequestType.Get,
    }),
  },
});

export default groupStatisticsSlice;
